import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Line,
} from 'recharts';

import type { DiscountEfficiencyData } from '../../types/report';

interface DiscountEfficiencyChartProps {
  data: DiscountEfficiencyData[];
}

const formatCurrency = (value: number) => {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(1)}억`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(0)}만`;
  }
  return value.toLocaleString();
};

export const DiscountEfficiencyChart = ({ data }: DiscountEfficiencyChartProps) => {
  return (
    <div className="space-y-6">
      <div className="h-80">
        <h4 className="mb-4 text-sm font-medium text-gray-700">할인율 구간별 매출 및 결제율</h4>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="discountRange" tick={{ fontSize: 12 }} />
            <YAxis
              yAxisId="left"
              tickFormatter={formatCurrency}
              tick={{ fontSize: 12 }}
              label={{ value: '판매가', angle: -90, position: 'insideLeft', fontSize: 12 }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              domain={[90, 100]}
              tick={{ fontSize: 12 }}
              label={{ value: '결제율(%)', angle: 90, position: 'insideRight', fontSize: 12 }}
            />
            <Tooltip
              formatter={(value, name) => {
                const numValue = Number(value);
                if (name === '총 유닛 판매가') return formatCurrency(numValue);
                if (name === '평균 결제율') return `${numValue}%`;
                return numValue;
              }}
            />
            <Legend />
            <Bar yAxisId="left" dataKey="totalUnitSalePrice" name="총 유닛 판매가" fill="#3b82f6" radius={[4, 4, 0, 0]} />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="avgPaymentRate"
              name="평균 결제율"
              stroke="#ef4444"
              strokeWidth={2}
              dot={{ fill: '#ef4444', r: 4 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>

      <div className="h-64">
        <h4 className="mb-4 text-sm font-medium text-gray-700">할인율 구간별 건당 평균 판매가</h4>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="discountRange" tick={{ fontSize: 12 }} />
            <YAxis tickFormatter={(v) => `${(v / 10000).toFixed(1)}만`} tick={{ fontSize: 12 }} />
            <Tooltip formatter={(value) => `${Number(value).toLocaleString()}원`} />
            <Bar dataKey="avgPricePerContract" name="건당 평균 판매가" fill="#10b981" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
